/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

/**
 * Migrated from: lego/page/etmf/list/apply-package/step1/package-contents/PackageRemoveConfirmationModal.jsx
 *
 * Simple confirmation modal for bulk package entry removal.
 * Reuses existing ModalConfirmation component from ~/components/shared/ModalConfirmation
 */

import React from 'react'
import { useServiceContext } from '../../../../../root'
import ModalConfirmation from '../../../../shared/ModalConfirmation'

interface PackageRemoveConfirmationModalProps {
  /** Callback to execute when user confirms removal */
  removePackage: () => void
  /** Controls modal visibility */
  show: boolean
  /** Callback when modal is closed */
  onClose: () => void
}

const PackageRemoveConfirmationModal: React.FC<PackageRemoveConfirmationModalProps> = ({
  removePackage,
  show,
  onClose
}) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  const handleConfirm = () => {
    removePackage()
    onClose()
  }

  return (
    <ModalConfirmation
      show={show}
      titleMsg={translate('SETTINGS_PACKAGE_CONTENTS_BULK_REMOVE_ENTRY_TITLE')}
      msg={
        <div className="confirm-remove-package">
          {translate('SETTINGS_PACKAGE_CONTENTS_BULK_REMOVE_ENTRY_QUESTION')}
        </div>
      }
      cancelTxt={translate('NO')}
      okTxt={translate('YES')}
      onCancel={onClose}
      onSubmit={handleConfirm}
    />
  )
}

export default PackageRemoveConfirmationModal
